import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import MemberAdditionalDocumentForm from '../../../components/forms/MemberAdditionalDocumentForm';
import { useMemberAdditionalDocumentApi } from '../../../hooks/useMemberAdditionalDocumentApi';
import { useNavigate, useParams } from 'react-router-dom';
import { MemberAdditionalDocumentDTO } from '../../../services/apiClient';

const MemberAdditionalDocumentEdit: React.FC = () => {
  const { getById, edit } = useMemberAdditionalDocumentApi();
  const [entityData, setEntityData] = useState<MemberAdditionalDocumentDTO | null>(null);
  const [isSubmitting, setIsSubmitting] = useState<boolean>(false);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Member Additional Documents', href: '/admin/documents' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching MemberAdditionalDocument data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      setIsSubmitting(true);
      await edit(id!, data);
      navigate('/admin/documents#additional');
    } catch (error) {
      console.error('Error updating MemberAdditionalDocument:', error);
    } finally{
      setIsSubmitting(false);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/documents"
      breadcrumbs={breadcrumbs}
      allowedRoles={['User']}
      requiredPermission='Manage.MemberAdditionalDocument.Edit'
    >
        {entityData ? (
          <MemberAdditionalDocumentForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/documents#additional')}
            isLoading={isSubmitting}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default MemberAdditionalDocumentEdit;